module.exports = '1.1.2';



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/version.js
// module id = 662
// module chunks = 3